import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { Field } from 'react-final-form'
import FormInputNumber from '../forms/final-form-fields/FormInputNumber'
import find from 'lodash/find'
import { PriceConverter } from '../helpers'
import { updateDiverInclusions } from '../../actions/resort-checkout-actions'
import { addRemoveFromCartTrack } from '../../gtm'
import { toast } from 'react-toastify'
import get from 'lodash/get'

const messages = defineMessages({
  notFound: {
    id: 'pricing_not_found',
    defaultMessage: `Unfortunately we've failed to find price for this dive in our database, please contact our support team.`,
  },
})

export default function DiveInclusions({ name, item, diveProducts, diveType }) {
  const intl = useIntl()
  const shopCurrency = useSelector((state) => state.shopCurrency)
  const shopKind = useSelector((state) => get(state, 'selectedShop.shopKind'))
  const [price, setPrice] = useState(0)
  const dispatch = useDispatch()
  const getPrices = (quantity) => {
    const includedPriceObject = find(diveProducts.prices, {
      numberOfInstances: item.numberOfDivesIncluded,
    })
    const currentPrice = find(diveProducts.prices, {
      numberOfInstances: quantity || item.quantity,
    })
    const price = Math.abs(
      currentPrice._perDiveSetPriceGross -
        includedPriceObject._perDiveSetPriceGross,
    )

    return {
      currentPriceId: currentPrice?.id,
      priceForOne: currentPrice?.priceNet,
      price,
      source: currentPrice?.source,
    }
  }
  const handleChange = (quantity, type) => {
    const { price, priceForOne } = getPrices(quantity)
    addRemoveFromCartTrack(type, quantity, {
      ...item,
      priceForOne,
      priceGross: price,
      divingInclusions: true,
    }, shopKind || 10)
  }

  useEffect(() => {
    if(item.numberOfDivesIncluded && item.quantity) {
      try {
        const { currentPriceId, price, source } = getPrices()
        dispatch(
          updateDiverInclusions({
            [item.key]: {
              pricing: currentPriceId,
              key: item.key,
              quantity: 1,
              source,
              diverNumber: item.key + 1,
              guestType: 10,
              numberOfInstances: item.quantity,
              divingItem: true,
              pk: item.pk,
              price:
                item.quantity >= item.numberOfDivesIncluded ? price : -price,
            },
          }),
        )
        setPrice(price)
      } catch (e) {
        toast.error(intl.formatMessage(messages.notFound))
        window?.Intercom('show')
        console.error(
          `No pricing item for current number of dives. Need to recalculate prices or ask backend to fix this issue. - ${e}`,
        )
      }
    }
  }, [item.quantity, item.numberOfDivesIncluded])

  return (
    <div className='t-row'>
      <div className='t-cell'>
        <span className='title'>
          <FormattedMessage
            id='change_the_type_dives'
            values={{
              diveType: diveType.toLocaleLowerCase(),
            }}
            defaultMessage='Change the # of {diveType} dives'
          />
        </span>
      </div>
      <div className='t-cell relative'>
        <div className='input-counter relative'>
          <Field name={`${name}.quantity`}>
            {(props) => (
              <FormInputNumber
                {...props}
                disabled
                maxNumber={item.maxPreorder || 100}
                plusMinusSeparate
                minNumber={item.isTwoTank ? 2 : 1}
                step={item.isTwoTank ? 2 : 1}
                onValueChange={handleChange}
              />
            )}
          </Field>
        </div>
        {item.isTwoTank && (
          <span className='counter-text'>
            {item.quantity / 2} x{' '}
            <FormattedMessage id='2-tank' defaultMessage='2-tank dives' />
          </span>
        )}
      </div>
      <div className='t-cell'>
        {item.quantity === item.numberOfDivesIncluded ? (
          <span className='counter-text'>
            <span className='green'>INCLUDED</span>
          </span>
        ) : (
          <span className={`price ${!item.quantity ? 'gray' : ''}`}>
            {item.quantity < item.numberOfDivesIncluded ? ' - ' : ' + '}
            <PriceConverter amount={price} currency={shopCurrency} />
          </span>
        )}
      </div>
      <p className='note'>
        <FormattedMessage id='note' defaultMessage='Note:' tagName='strong' />
        &nbsp;
        <FormattedMessage
          id='divers.note'
          defaultMessage={`Your pre-booked dives are clearly marked as either boat or shore dives and take place at standard dive sites. Unless otherwise indicated, they don't cover premium options like night dives or special dive sites and don't include national park fees or equipment beyond weights, weight belt and tanks. A great range of upgrades and extras can be selected below, with others bookable and payable after you arrive`}
        />
      </p>
    </div>
  )
}
